import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "d-inline-block" }
const _hoisted_2 = {
  key: 1,
  class: "text-secondary"
}

import { PhotosEventExtraField } from '@/types/api/calendar'
import { computed } from 'vue'
import AppImageLightBox from "@/components/app/AppImageLightBox.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'PhotosPresentation',
  props: {
    eventExtraField: null
  },
  setup(__props: any) {

const props = __props as { eventExtraField: PhotosEventExtraField };



// @ts-ignore
const imagePrefix = `${API_URL}/uploaded/images` // eslint-disable-line

const images = computed<string[]>((): string[] => props.eventExtraField.photos.map(({ filename }) => `${imagePrefix}/${filename}`))


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_unref(images).length > 0)
      ? (_openBlock(), _createBlock(AppImageLightBox, {
          key: 0,
          images: _unref(images),
          alt: props.eventExtraField.name,
          "as-link": true
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(props.eventExtraField.name), 1)
          ]),
          _: 1
        }, 8, ["images", "alt"]))
      : (_openBlock(), _createElementBlock("small", _hoisted_2, "No images"))
  ]))
}
}

})